import { makeRequestCreator } from './common.js'

const DeliveryAPI = {
  /**
   * 기존 배송정보 조회
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  getDeliveryInfo: (successCallback = ()=>{}, errorCallback = ()=>{}) => {
    makeRequestCreator(
      'getDeliveryInfo',
      {
        method: 'get',
        url: `/v2/delivery`,
      },
      successCallback,
      errorCallback
    )
  }
}

export default DeliveryAPI
